'use client'
import { Button } from '@/components/Button'
import { Loading } from '@/components/Loading'
import { BRANDSIDE_SERVICE_URL } from '@/config/site'
import { MktuCard } from '@/domains/Site/components/MktuCard'
import { Title } from '@/domains/WebApp/components/Title'
import { mktuStore } from '@/domains/WebApp/store/Mktu'
import { MKTU_CLASS_CATEGORY } from '@/models/Mktu'
import { MktuClassWord } from '@/services/Api/generated'
import { MktuClassPopup } from '@/shared/Mktu/components'
import { SearchMktuClasses } from '@/shared/Mktu/components/SearchMktuClasses'
import { MktuClassStore } from '@/store/Mktu/MktuClass'
import { mktuClassesList } from '@/store/Mktu/MktuClassesList'
import { observer } from 'mobx-react-lite'
import { FC, useCallback, useLayoutEffect, useState } from 'react'
import styles from './Mktu.module.scss'
import { MktuClasses } from './components/MktuClasses'

const searchStore = mktuStore.searchStore

interface MktuProps {
  searchQuery: string
}
export const Mktu: FC<MktuProps> = observer(({ searchQuery }) => {
  const [detailsMktuClass, setDetailsMktuClass] =
    useState<MktuClassStore | null>(null)

  const showDetailsMktuClass = useCallback((classNumber: number) => {
    const mktuClass = mktuStore.selectedMktuClasses.find(
      (mktuClass) => mktuClass.number === classNumber
    )
    if (mktuClass != null) {
      setDetailsMktuClass(mktuClass)
    }
  }, [])

  const hideDetailsMktuClass = useCallback(() => {
    setDetailsMktuClass(null)
  }, [])

  const applyWordsDetailsMktuClass = useCallback(
    (words: Array<MktuClassWord['word']>) => {
      if (detailsMktuClass == null) {
        return
      }

      detailsMktuClass.setSelectedWordsNames(words)
      hideDetailsMktuClass()
    },
    [detailsMktuClass, hideDetailsMktuClass]
  )

  useLayoutEffect(() => {
    mktuClassesList.loader.request()
  }, [])

  const selectMktuClass = useCallback((newMktuClass: MktuClassStore) => {
    mktuStore.setSelectedMktuClasses([
      ...mktuStore.selectedMktuClasses,
      newMktuClass,
    ])
  }, [])

  return (
    <>
      <Title className={styles.title} title="Найти класс МКТУ" />
      <SearchMktuClasses
        store={searchStore}
        onApply={mktuStore.addFoundClasses}
        className={styles.searchButton}
      />
      {mktuStore.selectedMktuClasses.length !== 0 ? (
        <>
          <div className={styles.list}>
            {mktuStore.selectedMktuClasses.map((mktuClassStore) => (
              <MktuCard
                key={mktuClassStore.number}
                number={mktuClassStore.number}
                words={mktuClassStore.selectedWords}
                onShowDetails={showDetailsMktuClass}
              />
            ))}
          </div>
          <div className={styles.buttons}>
            <Button href="/calculator" className={styles.calculateButton}>
              Рассчитать стоимость регистрации
            </Button>
            <Button
              href={BRANDSIDE_SERVICE_URL ?? ''}
              target="_blank"
              className={styles.registrateButton}
            >
              Подать заявку на регистрацию
            </Button>
          </div>
        </>
      ) : null}
      <div className={styles.content}>
        {mktuClassesList.loader.loading ? (
          <Loading />
        ) : (
          <MktuClasses
            className={styles.mktuClassesSidebar}
            productClass={
              mktuClassesList.mapClassesByType[MKTU_CLASS_CATEGORY.PRODUCT]
            }
            servicesClass={
              mktuClassesList.mapClassesByType[MKTU_CLASS_CATEGORY.SERVICE]
            }
            selectedClasses={mktuStore.selectedMktuClasses}
            selectClass={selectMktuClass}
          />
        )}
      </div>
      {detailsMktuClass ? (
        <MktuClassPopup
          onClose={hideDetailsMktuClass}
          onApplyWords={applyWordsDetailsMktuClass}
          withDescriptionClass={false}
          mktuClass={detailsMktuClass}
        />
      ) : null}
    </>
  )
})
